import { Row } from '@tanstack/react-table';

import { TAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { IActionMenu } from '@interfaces/components/table';

import { EMenuActionsTypes, ESnackbarTypes, TMenuActionsTypes } from '@enums/common';

import { responseMessages } from '@constants/responseMessages';

export const getIdsGroupAction = ({
	actionId,
	selectedFlatRows,
	dispatch,
	rows,
	keysForCheckedIds,
}: {
	actionId: TMenuActionsTypes;
	selectedFlatRows: Row<any>[];
	dispatch: TAppDispatch;
	rows: Row<any>[];
	keysForCheckedIds: string[];
}): string[] => {
	if (actionId === EMenuActionsTypes.selected && selectedFlatRows.length === 0) {
		dispatch(setSnackbar({
			message: responseMessages.nothingIsSelected,
			type: ESnackbarTypes.error,
		}));

		return [];
	}

	const preparedRows = actionId === EMenuActionsTypes.selected
		? selectedFlatRows
		: actionId === EMenuActionsTypes.currentPage
			? rows
			: [];

	const selectedIds = keysForCheckedIds?.length > 1
		? preparedRows.map((row) => ({
			...(keysForCheckedIds?.reduce<Record<string, any>>((acc, key) => {
				acc[key] = row.original[key];

				return acc;
			}, {})),
		}))
		: preparedRows.map((row) => row.original[keysForCheckedIds[0]]);

	return selectedIds.filter(Boolean);
};

export const modifyMenuActionsBasedOnSelection = (
	options: IActionMenu<TMenuActionsTypes>[],
	selectedIds: Record<string, any>,
): IActionMenu<TMenuActionsTypes>[] => {
	return options.find(({ id }) => id === EMenuActionsTypes.selected)
		? options.map((action) =>
			action.id === EMenuActionsTypes.selected
				? { ...action, disabled: action.disabled || !Object.keys(selectedIds).length }
				: action,
		)
		: options;
};

export const modifyMenuActionsBasedOnFilters = (
	options: IActionMenu<TMenuActionsTypes>[],
	isDirtyFilters: boolean,
): IActionMenu<TMenuActionsTypes>[] => {
	return options.find(({ id }) => id === EMenuActionsTypes.allFiltered)
		? options.map((action) =>
			action.id === EMenuActionsTypes.allFiltered
				? { ...action, disabled: action.disabled || !isDirtyFilters }
				: action,
		)
		: options;
};

export const modifyMenuActionsTextBasedOnCount = (
	options: IActionMenu<TMenuActionsTypes>[],
): IActionMenu<TMenuActionsTypes>[] => {
	return options.map((action) => {
		return ({ ...action, text: action.count ? `${action.text} (${action.count})` : action.text });
	});
};
